import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";

const safeWh = (wh: any) => (wh && wh !== "undefined" && wh !== "null" ? wh : "allWh");
const safeVal = (val: any) => (val && val !== "undefined" && val !== "null" && String(val).trim() !== "" ? encodeURIComponent(String(val).trim()) : "all");

export const ReportsApi = createApi({
  reducerPath: "reportsApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["Reports"],
  endpoints: (builder) => ({
    CustomerWiseSales: builder.query<void[], any>({
      query: ({ aamarId, warehouse, startDate, endDate, customerId }) =>
        `/reports/customerWiseSales/${startDate}/${endDate}/${safeWh(warehouse)}/${aamarId}/${safeVal(customerId)}`,
      providesTags: ["Reports"],
    }),
    DateWiseSalesDue: builder.query<void[], any>({
      query: ({ aamarId, warehouse, startDate, endDate }) =>
        `/reports/customerWiseSales/${startDate}/${endDate}/${safeWh(warehouse)}/${aamarId}`,
      providesTags: ["Reports"],
    }),
    SaleReturnWise: builder.query<void[], any>({
      query: ({ aamarId, warehouse, startDate, endDate, customerId }) =>
        `/reports/saleReturnWise/${startDate}/${endDate}/${safeWh(warehouse)}/${aamarId}/${safeVal(customerId)}`,
      providesTags: ["Reports"],
    }),
    InvoiceWiseProfit: builder.query<void[], any>({
      query: ({ aamarId, warehouse, startDate, endDate }) =>
        `/reports/invoiceWiseProfit/${startDate}/${endDate}/${safeWh(warehouse)}/${aamarId}`,
      providesTags: ["Reports"],
    }),
    ProductWiseSales: builder.query<void[], any>({
      query: ({ aamarId, warehouse, startDate, endDate, search }) =>
        `/reports/productWiseSales/${startDate}/${endDate}/${safeWh(warehouse)}/${aamarId}/${safeVal(search)}`,
      providesTags: ["Reports"],
    }),
    UserWiseSales: builder.query<void[], any>({
      query: ({ aamarId, warehouse, startDate, endDate, userId }) =>
        `/reports/userWiseSales/${startDate}/${endDate}/${safeWh(warehouse)}/${aamarId}/${safeVal(userId)}`,
      providesTags: ["Reports"],
    }),
    InvoiceWiseProduct: builder.query<void[], any>({
      query: ({ aamarId, warehouse, startDate, endDate, invoiceId }) =>
        `/reports/invoiceWiseProduct/${startDate}/${endDate}/${safeWh(warehouse)}/${aamarId}/${safeVal(invoiceId)}`,
      providesTags: ["Reports"],
    }),
    DateWisePurchase: builder.query<void[], any>({
      query: ({ aamarId, warehouse, startDate, endDate }) =>
        `/reports/dateWisePurchase/${startDate}/${endDate}/${safeWh(warehouse)}/${aamarId}`,
      providesTags: ["Reports"],
    }),
    SupplierWisePurchase: builder.query<void[], any>({
      query: ({ aamarId, warehouse, startDate, endDate, supplier }) =>
        `/reports/supplierWisePurchase/${startDate}/${endDate}/${safeWh(warehouse)}/${aamarId}/${safeVal(supplier)}`,
      providesTags: ["Reports"],
    }),
    ProductWisePurchase: builder.query<void[], any>({
      query: ({ aamarId, warehouse, startDate, endDate, productId }) =>
        `/reports/productWisePurchase/${startDate}/${endDate}/${safeWh(warehouse)}/${aamarId}/${safeVal(productId)}`,
      providesTags: ["Reports"],
    }),
    UserWisePurchase: builder.query<void[], any>({
      query: ({ aamarId, warehouse, startDate, endDate, userId }) =>
        `/reports/userWisePurchase/${startDate}/${endDate}/${safeWh(warehouse)}/${aamarId}/${safeVal(userId)}`,
      providesTags: ["Reports"],
    }),
    ProfitLossReport: builder.query<void[], any>({
      query: ({ aamarId, warehouse, startDate, endDate }) =>
        `/reports/lossProfit/${startDate}/${endDate}/${safeWh(warehouse)}/${aamarId}`,
      providesTags: ["Reports"],
    }),
  }),
});

export const {
  useCustomerWiseSalesQuery,
  useDateWiseSalesDueQuery,
  useSaleReturnWiseQuery,
  useInvoiceWiseProfitQuery,
  useProductWiseSalesQuery,
  useUserWiseSalesQuery,
  useInvoiceWiseProductQuery,
  useDateWisePurchaseQuery,
  useSupplierWisePurchaseQuery,
  useProductWisePurchaseQuery,
  useUserWisePurchaseQuery,
  useProfitLossReportQuery,
} = ReportsApi;

export default ReportsApi;
